<template>
  <div>
    This content is under development.
    <div class="actions">
      <a href="#" @click.prevent="$router.go(-1)">Go back</a>
    </div>
  </div>
</template>

<!--/////////////////////////////////////////////////////////////////////////-->

<script>
export default {
  name: 'coming-soon'
}
</script>

<!--/////////////////////////////////////////////////////////////////////////-->

<style scoped lang="scss">
.actions {
  margin-top: 20px;
}
</style>
